import { useState, useEffect } from 'react';
import axios from 'axios';

const API_BASE = 'https://landingstudio.co.kr';

/**
 * landingstudio API에서 템플릿 데이터를 가져오는 훅
 * @param {string} adNumber - 광고 번호 (예: "A001")
 * @returns {{data: object|null, loading: boolean, error: Error|null}}
 */
export const useTemplateData = (adNumber) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      if (!adNumber) {
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        setError(null);

        const response = await axios.get(`${API_BASE}/api/landings/${adNumber}`);

        if (response.data) {
          // API가 { success: true, data: {...} } 형식으로 반환하는 경우
          const actualData = response.data.data || response.data;
          setData(actualData);
        } else {
          throw new Error('No data received from API');
        }
      } catch (err) {
        console.error('Template data fetch error:', err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [adNumber]);

  return { data, loading, error };
};

export default useTemplateData;
